// removed by extract-text-webpack-plugin
module.exports = {"UnselectableTextVisible":"_3dVrR-zbvMFwSuEH8guwxP","UnselectableText":"_21yWRS6iaeO0EDyYlttyVJ"};


//////////////////
// WEBPACK FOOTER
// ./src/layout/Dashboard/MainPanel/ClientChatSettings/Formular/style.css
// module id = 849
// module chunks = 0